<template>
  <div class="verify-code">
    <div class="verify-code-list"
         @click="$refs.input.focus()"
    >
      <div v-for="(item,index) in numList"
           :key="index"
           class="item"
           :class="{ 'active': inputValue.length === index && inputFocus }"
      >
        {{ item }}
      </div>
    </div>
    <input class="verify-code-input"
           ref="input"
           type="tel"
           maxlength="6"
           v-model="inputValue"
           @focus="inputFocus = true"
           @blur="inputFocus = false"
    />
  </div>
</template>

<script>
  export default {
    props: {
      code: String,
    },
    data() {
      return {
        inputValue: '',
        inputFocus: false,
      };
    },
    watch: {
      inputValue(val) {
        this.inputValue = val.replace(/\D/g, '');
        this.$emit('update:code', this.inputValue);
      },
    },
    computed: {
      numList() {
        const numList = this.inputValue.split('');
        numList.length = 6;
        return numList;
      },
    },
    created() {
      setTimeout(() => {
        this.$refs.input.focus();
      }, 1500);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .verify-code {
    &-list {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        width: 80px;
        height: 84px;
        box-sizing: border-box;
        text-align: center;
        color: @color-text-base;
        font-size: 64px;
        font-weight: @font-weight-bold;
        line-height: 1;
        padding-bottom: 20px;
        border-bottom: 1px solid #ccc;
        &.active {
          border-bottom: 1px solid #666;
        }
      }
    }
    &-input {
      position: absolute;
      top: 0;
      opacity: 0;
      z-index: -1;
    }
  }
</style>
